const SANDBOX_SESSION_KEY = "sandbox_session";

/**
 * The sandbox session lives on the server, so a failing `GET /sandbox/`
 * (for example a 403 inside the sandbox) would otherwise hide the way back to
 * the live company. This local marker keeps "Switch back" reachable.
 */
export function hasSandboxSessionMark() {
  try {
    return localStorage.getItem(SANDBOX_SESSION_KEY) === "1";
  } catch {
    return false;
  }
}

export function setSandboxSessionMark(isSandboxSession) {
  try {
    if (isSandboxSession) {
      localStorage.setItem(SANDBOX_SESSION_KEY, "1");
    } else {
      localStorage.removeItem(SANDBOX_SESSION_KEY);
    }
  } catch {
    // Storage is unavailable (private mode) — the server stays the source of truth.
  }
}

const SANDBOX_RECOVERY_KEY = "sandbox_access_recovery";

export function hasSandboxAccessRecoveryMark() {
  try {
    return sessionStorage.getItem(SANDBOX_RECOVERY_KEY) === "1";
  } catch {
    return false;
  }
}

export function setSandboxAccessRecoveryMark() {
  try {
    sessionStorage.setItem(SANDBOX_RECOVERY_KEY, "1");
  } catch {
    /* ignore */
  }
}

export function clearSandboxAccessRecoveryMark() {
  try {
    sessionStorage.removeItem(SANDBOX_RECOVERY_KEY);
  } catch {
    /* ignore */
  }
}
